import styled from "styled-components";

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  margin-right: 16px;

  &:last-child {
    margin-right: 0;
  }

  label {
    font-family: ${({ theme }) => theme.fonts.titleBold};
    font-size: 14px;
    
    color: ${({ theme }) => theme.colors.black};
    margin-bottom: 8px;
  }

  input {
    width: 100%;
    height: 54px;
    border-radius: 5px;
    border: 1px #dedede solid;
    padding: 16px;
    word-wrap: break-word;
    font-size: 14px;
    font-family: ${({ theme }) => theme.fonts.default};
    color: ${({ theme }) => theme.colors.black};
  }

  span {
    font-size: 14px;
    font-family: ${({ theme }) => theme.fonts.titleSemiBold};
    font-weight: bold;
    color: ${({ theme }) => theme.colors.danger};
    margin: 4px 0;
  }
`;
